import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const CartonPackingEndPoints = {
  GET_CARTON_PACKING_DASHBOARD_COUNT: 'GET_CARTON_PACKING_DASHBOARD_COUNT',
  GET_CARTON_PACKING_BUYER_LISTING: 'GET_CARTON_PACKING_BUYER_LISTING',
  GET_CARTON_PACKING_SET_PACK_LISTING: 'GET_CARTON_PACKING_SET_PACK_LISTING',
  GET_CARTON_PACKING_ALL_TRANSACTIONS: 'GET_CARTON_PACKING_ALL_TRANSACTIONS',
  GET_CARTON_DETAILS: 'GET_CARTON_DETAILS',
  CREATE_CARTON: 'CREATE_CARTON',
  EDIT_CARTON: 'EDIT_CARTON',
  GET_SET_PACK_LISTING: 'GET_SET_PACK_LISTING',
};

type TCartonPackingEndPoints = typeof CartonPackingEndPoints;
type TCartonPackingEndPointsTypes = keyof TCartonPackingEndPoints;
type TEnvVariables = TCartonPackingEndPoints;

@Injectable({ providedIn: 'root' })
export class CartonPackingEnvProvider {
  private protocol = 'http';
  private service_host = '';

  private env_vars: TEnvVariables = {
    GET_CARTON_PACKING_DASHBOARD_COUNT: '',
    GET_CARTON_PACKING_BUYER_LISTING: '',
    GET_CARTON_PACKING_SET_PACK_LISTING: '',
    GET_CARTON_PACKING_ALL_TRANSACTIONS: '',
    GET_CARTON_DETAILS: '',
    CREATE_CARTON: '',
    EDIT_CARTON: '',
    GET_SET_PACK_LISTING: 'GET_SET_PACK_LISTING',
  };

  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol !== null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host !== null) {
      this.service_host = ENV.service_host;
    }

    this.registerVars(ENV);
  }
  registerVars(environment: TInputAppEnvironmentVars) {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;
    this.env_vars.GET_CARTON_PACKING_DASHBOARD_COUNT =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPackCartonDashboard/count';
    this.env_vars.GET_CARTON_PACKING_BUYER_LISTING =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPackCarton/buyerPackListing';
    this.env_vars.GET_CARTON_PACKING_SET_PACK_LISTING =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPackCarton/fetchCartonLevelSetPackListing';
    this.env_vars.GET_CARTON_PACKING_ALL_TRANSACTIONS =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPackCarton/listing';
    this.env_vars.GET_CARTON_DETAILS =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPackCarton/getCartonDetails';
    this.env_vars.CREATE_CARTON =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPackCarton/create';
    this.env_vars.EDIT_CARTON =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/setPackCarton/editCarton';
    this.env_vars.GET_SET_PACK_LISTING =
      HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v2/setPackCarton/listing';
  }

  getEnvVar(key: TCartonPackingEndPointsTypes): string {
    return this.env_vars[key];
  }
}
